import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getParentIframeAllowedOrigin } from "environment";
import { loginSelectors } from "state/selectors";
import logger from "utils/logger";

const IframeAuthNotifier = () => {
  const isLoggedIn = useSelector(loginSelectors.isLoggedIn);

  useEffect(() => {
    if (window.self !== window.top && isLoggedIn) {
      try {
        window.parent.postMessage(
          {
            action: "login_success",
          },
          getParentIframeAllowedOrigin()
        );
      } catch (error) {
        logger.error("Failed to post message to parent iframe:", error);
      }
    }
  }, [isLoggedIn]);

  return null;
};

export default IframeAuthNotifier;
